<template>
  <div class="container" style="max-width:100%;padding:0;">
    <!-- <div v-if="!forConasi" class="header-page">
    </div> -->
    <div class="py-4"></div>
    <div class="profile-page">
      <!-- Avatar -->
      <div style="display:flex;justify-content:center;">
        <avatar
          :username="this.fullName"
          backgroundColor="#fff"
          color="#0097A7"
          :size="150"
        ></avatar>
      </div>
      <!-- Full name -->
      <div class=" mt-3" style="width: 100%;">
        <form>
          <div class="title-form">
            THÔNG TIN CÁ NHÂN
            <button type="button" class="btn-close-form" @click="onBack($event)">
              &times;
            </button>
          </div>
          <div class="form-row">
            <!-- Username -->
            <div class="form-group col-md-6">
              <div class="col-xs-6">
                <label for="inputFullname">{{ $t('profile.username') }}*</label>
                <input
                  v-model="username"
                  type="text"
                  class="form-control"
                  id="inputFullname"
                  :placeholder="$t('profile.username')"
                  disabled
                />
              </div>
              <!-- <span class="medium">{{ GET_CURRENT_ACCOUNT.username }}</span> -->
            </div>
            <!-- Email -->
            <div class="form-group col-md-6">
              <div class="col-xs-6">
                <label for="inputFullname">{{ $t('profile.emailAddress') }}*</label>
                <input
                  v-model="email"
                  type="text"
                  class="form-control"
                  id="inputFullname"
                  :placeholder="$t('profile.emailAddress')"
                  disabled
                />
              </div>
              <!-- <span class="medium">{{ GET_CURRENT_ACCOUNT.email }}</span> -->
            </div>
            <!-- <div class="form-group col-md-6">
              <label for="inputPassword">Mật khẩu</label>
              <input
                type="password"
                class="form-control"
                id="inputPassword"
                placeholder="Mật khẩu"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="inputConfirmPassword">Xác nhận mật khẩu</label>
              <input
                type="password"
                class="form-control"
                id="inputConfirmPassword"
                placeholder="Xác nhận mật khẩu"
              />
            </div> -->
            <div class="form-group col-md-6">
              <label for="inputFullname">{{ $t('profile.fullName') }}*</label>
              <input
                v-model="fullName"
                type="text"
                class="form-control"
                id="inputFullname"
                :placeholder="$t('profile.fullName')"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="inputPhone">{{ $t('profile.phone') }}</label>
              <input
                v-model="phone"
                type="number"
                class="form-control"
                id="inputPhone"
                :placeholder="$t('profile.phone')"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="inputPhone">{{ $t('profile.dateOfBirth') }}</label>
              <div class="input-date-of-birth">
                <date-picker v-model="birtdate" valueType="format" :format="'DD/MM/YYYY'" placeholder="DD/MM/YYYY" style="border:none;"></date-picker>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label for="inputGender">{{ $t('profile.gender') }}</label>
              <select class="selectbox-gender form-control" id="SelectboxGender" v-model="gender" style="font-size:14px;">
                <option disabled value="">Please select one</option>
                <option value="1">Nam</option>
                <option value="2">Nữ</option>
                <option value="3">Khác</option>
              </select>
            </div>
            <div class="form-group w-100">
              <label for="inputaddress">{{ $t('profile.address') }}</label>
              <b-input-group>
                <b-form-input
                  v-model="fullAddress"
                  type="text"
                  id="inputaddress"
                  class="form-control"
                  :placeholder="$t('profile.address')"
                  readonly
                />
                <b-input-group-append>
                  <b-button size="sm" variant="outline-secondary" @click="onEditAddress">...</b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>
          <div class="row" style="margin: auto;">
            <div class="mr-2">
              <button
                style="width:6rem;;height:40px; font-size: 0.8em;"
                class="button-save btn my-1 my-sm-0 btn-sm"
                @click="handleNextPage($event)"
              >
                {{ $t('common.changePassword') }}
              </button>
            </div>
            <div class="mr-2">
              <button
                style="width:5rem;;height:40px; font-size: 0.8em;"
                type="submit"
                class="button-save btn my-1 my-sm-0 btn-sm"
                @click="onCheckFormpProfile($event)"
              >
                {{ $t('common.save') }}
              </button>
            </div>
            <div class="mr-2" v-if="ENABLE_BINDING_GOOGLE">
              <div class="text-center social-btn">
                <button
                  v-if="googleSocialNetworkData"
                  style="height:40px; font-size: 0.8em;"
                  type="button"
                  class="btn btn-danger btn-block"
                  disabled
                >
                  <i class="fab fa-google"/> {{ ellipsisLongText(googleSocialNetworkData.full_name, 10) }}
                </button>
                <google-button-component
                  v-else
                  :data-width="147"
                  :data-text="'signup_with'"
                  @onEmitData="googleBtnEmitData"
                />
              </div>
            </div>
            <div v-if="ENABLE_BINDING_FACEBOOK">
              <div class="text-center social-btn">
                <button
                  v-if="facebookSocialNetworkData"
                  style="height:40px; font-size: 0.8em;"
                  type="button"
                  class="btn btn-primary btn-block"
                  disabled
                >
                  <i class="fab fa-facebook"/> {{ ellipsisLongText(facebookSocialNetworkData.full_name, 10) }}
                </button>
                <button
                  v-if="facebookSocialNetworkData === null"
                  style="height:40px; font-size: 0.8em;"
                  type="button"
                  class="btn btn-primary btn-block"
                  @click="postLoginWithFacebook(isConfirmAddSocialNetwork=false)">
                  <i class="fab fa-facebook"/> {{ $t('common.facebookAccountLink') }}
                </button>
              </div>
            </div>
            <!-- <div>
              <button
                type="submit"
                class="btn btn-outline-danger my-2 my-sm-0 btn-sm"
                @click="onLogout($event)"
              >
                {{ $t('common.logout') }}
              </button>
            </div> -->
          </div>
        </form>
      </div>
    </div>
    <!--  -->
    <div
      id="notificationModal"
      class="modal fade"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-confirm">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ $t('common.notification') }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
              @click="onClickCloseModal"
            >
              &times;
            </button>
          </div>
          <div class="modal-body text-center">
            <p>{{ confirmModalTitle }}</p>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-success float-right btn-sm"
              data-dismiss="modal"
              @click="confirmAddSocialNetwork"
            >
              <span>{{ $t("common.confirm") }}</span>
            </button>
            <button
              class="btn btn-default float-left btn-sm"
              data-dismiss="modal"
              @click="onClickCloseModal"
              style="background: #bdbdbd !important"
            >
              <span>{{ $t("common.close") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both;"></div>
    <editAddressModal
      ref="editAddressModal"
      @onConfirm="onUpdateAddress"
    />
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import { mapGetters, mapActions } from "vuex";
import functionUtils from "Utils/functionUtils";
import { FOR_CONASI_TARGET } from 'Utils/constants'
import { isCookieEnabled, getCookie } from "tiny-cookie";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import "vue2-datepicker/locale/vi";
import SocialNetworkType from 'Enum/socialNetworkType'
import $ from "jquery";
import { initFbsdk } from '@/config/facebook_oAuth.js'
import EditAddressModal from 'Components/EditAddressModal'
import GoogleButtonComponent from 'Components/GoogleButtonComponent'

export default {
  components: {
    avatar: Avatar,
    GoogleButtonComponent,
    DatePicker,
    EditAddressModal
  },
  data: () => ({
    id: null,
    username: null,
    fullName: "",
    email: null,
    gender: null,
    birtdate: null,
    phone: null,
    address: {
      longitude: null,
      latitude: null,
      province: null,
      district: null,
      ward: null,
      street: null
    },
    fullAddress: null,
    forConasi: FOR_CONASI_TARGET,
    googleSocialNetworkData: null,
    facebookSocialNetworkData: null,
    ENABLE_BINDING_GOOGLE: process.env.VUE_APP_ENABLE_BINDING_GOOGLE.trim() === 'true',
    ENABLE_BINDING_FACEBOOK: process.env.VUE_APP_ENABLE_BINDING_FACEBOOK.trim() === 'true',
    confirmModalTitle: '',
    socialNetworkTypeSelect: null,
    socialNetworkSelect: null,
    isConfirmAddSocialNetwork: false
  }),
  computed: {
    ...mapGetters(["GET_CURRENT_ACCOUNT"]),
  },
  watch: {
    GET_CURRENT_ACCOUNT() {
      this.id = this.GET_CURRENT_ACCOUNT.id;
      this.username = this.GET_CURRENT_ACCOUNT.username;
      if (
        !functionUtils.isNull(this.GET_CURRENT_ACCOUNT.lastname) &&
        !functionUtils.isNull(this.GET_CURRENT_ACCOUNT.firstname)
      ) {
        this.fullName =
          this.GET_CURRENT_ACCOUNT.lastname +
          " " +
          this.GET_CURRENT_ACCOUNT.firstname;
      }
      this.email = this.GET_CURRENT_ACCOUNT.email;
      this.gender = this.GET_CURRENT_ACCOUNT.gender;
      this.birtdate = this.formatDate(this.GET_CURRENT_ACCOUNT.birth_date);
      this.phone = this.GET_CURRENT_ACCOUNT.phone;
      this.address.longitude = this.GET_CURRENT_ACCOUNT.longitude;
      this.address.latitude = this.GET_CURRENT_ACCOUNT.latitude;
      this.address.province = this.GET_CURRENT_ACCOUNT.province;
      this.address.district = this.GET_CURRENT_ACCOUNT.district;
      this.address.ward = this.GET_CURRENT_ACCOUNT.ward;
      this.address.street = this.GET_CURRENT_ACCOUNT.street;
      this.getFullAddress()
    },
  },
  created() {
    this.SET_USER_DATA();
    this.getSocialNetwork()
    initFbsdk()
  },
  methods: {
    /**
     * ellipsis Long Text
     */
    ellipsisLongText: function (value, len) {
      return functionUtils.ellipsisLongText(value, len)
    },
    /**
     * Back
     */
    onBack: function (event) {
      event.preventDefault()
      window.history.back()
    },
    /**
     * Valid require
     */
    validRequire: function(fieldRequire) {
      if (fieldRequire != "" && fieldRequire != null) {
        return true;
      } else {
        return false;
      }
    },

    /**
     * Logout
     */
    onLogout: function(event) {
      event.preventDefault();
      let token = isCookieEnabled() ? getCookie("token") : null;
      this.LOGOUT(token)
        .then(
          function() {
            this.$router.push({
              name: "Home",
            });
          }.bind(this)
        )
        .catch(
          function() {
            this.$router.push({
              name: "Home",
            });
          }.bind(this)
        );
    },
    /**
     * Check form
     */

    onCheckFormpProfile: function (event) {
      event.preventDefault()
      this.fieldBlured = true;
      if (this.validRequire(this.fullName)) {
        if (!functionUtils.validatePhone(this.phone) && this.validRequire(this.phone)) {
          this.$toast.clear()
          this.$toast.error(this.$t('common.notificationToast.incorrectTelephoneNumber'), {
            position: "bottom-left",
            timeout: 1500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        } else {
          this.onUpdateProfile()
          this.SET_USER_DATA();
        }
      } else {
        this.$toast.clear()
        this.$toast.error(this.$t('common.notificationToast.youAreMissingInformation'), {
          position: "bottom-left",
          timeout: 1500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: "button",
          icon: true,
          rtl: false
        });
      }
    },

    /**
     * Update profile
     */
    onUpdateProfile: function() {
      let lastName = functionUtils.getFirstLastName(this.fullName).lastName;
      let firstName = functionUtils.getFirstLastName(this.fullName).firstName;
      let filter = {
        lastName: lastName,
        firstName: firstName,
        birthDate: this.birtdate,
        phone: this.phone,
        gender: this.gender,
        longitude: this.address.longitude,
        latitude: this.address.latitude,
        province: this.address.province,
        district: this.address.district,
        ward: this.address.ward,
        street: this.address.street
      };
      this.UPDATE_CURRENT_USER({ id: this.id, ...filter })
        .then(
          function() {
            this.$toast.clear()
            this.$toast.success(this.$t('common.notificationToast.success'), {
              position: "bottom-left",
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$toast.clear()
            this.$toast.error(this.$t(functionUtils.errorResponse(error.response)), {
              position: "bottom-left",
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          }.bind(this)
        );
    },

    handleNextPage(event) {
      sessionStorage.setItem('Email', this.email);
      event.preventDefault();
      this.$router.push({
        path: '/change-password',
      });
    },
    // Format value Birth Date

    formatDate(value) {
      var date = new Date(value);
      let dateFormat =
        ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' +
        ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' +
        date.getFullYear()
      return dateFormat
    },
    googleBtnEmitData: function (data) {
      this.postGoogleLogin(data)
      this.socialNetworkSelect = data
    },
    onClickLoginGoogle: function () {
      this.$gAuth
        .signIn()
        .then(GoogleUser => {
          // on success do something
          var profile = GoogleUser.getBasicProfile();
          if (Object.keys(profile).length > 0) {
            let userProfile = {
              id: profile.getId(),
              fullName: profile.getName(),
              avatarUrl: profile.getImageUrl(),
              email: profile.getEmail()
            }
            this.postGoogleLogin(userProfile)
            this.socialNetworkSelect = userProfile
          }
        })
        // .catch(error => {
        //   console.log('error', error)
        // })
    },
    postGoogleLogin: function (userInfo) {
      let googleSocialNetwork = SocialNetworkType.GOOGLE
      this.socialNetworkTypeSelect = googleSocialNetwork
      let data = {
        socialNetworkType: googleSocialNetwork,
        fullName: userInfo && userInfo.fullName,
        socialId: userInfo && userInfo.id,
        email: userInfo && userInfo.email,
        avatarUrl: userInfo && userInfo.avatarUrl,
        isConfirmAddSocialNetwork: this.isConfirmAddSocialNetwork
      }
      this.SOCIAL_NETWORK_LOGIN(data).then(
        function () {
          this.getSocialNetwork()
        }.bind(this)
      ).catch(
        function (error) {
          if (!functionUtils.isNull(error.response.data.isShowModalConfirm)) {
            this.onShowModalConfirmAddSocialNetwork()
          } else {
            this.$toast.clear()
            this.$toast.error(this.$t(functionUtils.errorResponse(error.response)), {
              position: "bottom-left",
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          }
        }.bind(this)
      )
    },
    // facebook
    postLoginWithFacebook () {
      window.FB.login(response => {
        if (response && response.authResponse) {
          window.FB.api(`/${response.authResponse.userID}`, userResponse => {
            if (userResponse) {
              this.postFacebookLogin(userResponse)
              this.socialNetworkSelect = userResponse
            }
          }, { scope: 'email' })
        }
      }, { scope: 'email' })
    },
    postFacebookLogin: function (userInfo) {
      let facebookSocialNetwork = SocialNetworkType.FACEBOOK
      this.socialNetworkTypeSelect = facebookSocialNetwork
      let data = {
        socialNetworkType: facebookSocialNetwork,
        fullName: userInfo && userInfo.name,
        socialId: userInfo && userInfo.id,
        email: null,
        avatarUrl: null,
        isConfirmAddSocialNetwork: this.isConfirmAddSocialNetwork
      }
      this.SOCIAL_NETWORK_LOGIN(data).then(
        function () {
          this.getSocialNetwork()
        }.bind(this)
      ).catch(
        function (error) {
          if (!functionUtils.isNull(error.response.data.isShowModalConfirm)) {
            this.onShowModalConfirmAddSocialNetwork()
          } else {
            this.$toast.clear()
            this.$toast.error(this.$t(functionUtils.errorResponse(error.response)), {
              position: "bottom-left",
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          }
        }.bind(this)
      )
    },
    getSocialNetwork: function () {
      this.GET_SOCIAL_NETWORK().then(
        function (res) {
          let dataList = res.data
          let googleSocialNetworkIndex = dataList.findIndex(x => x.social_type === SocialNetworkType.GOOGLE)
          this.googleSocialNetworkData = googleSocialNetworkIndex !== -1 ? dataList[googleSocialNetworkIndex] : null
          let facebookSocialNetworkIndex = dataList.findIndex(x => x.social_type === SocialNetworkType.FACEBOOK)
          this.facebookSocialNetworkData = facebookSocialNetworkIndex !== -1 ? dataList[facebookSocialNetworkIndex] : null
        }.bind(this)
      ).catch(
        function () {}
      )
    },
    confirmAddSocialNetwork: function () {
      this.isConfirmAddSocialNetwork = true
      if (this.socialNetworkTypeSelect === SocialNetworkType.GOOGLE) {
        this.postGoogleLogin(this.socialNetworkSelect)
      } else if (this.socialNetworkTypeSelect === SocialNetworkType.FACEBOOK) {
        this.postFacebookLogin(this.socialNetworkSelect)
      }
    },
    onShowModalConfirmAddSocialNetwork: function () {
      $("#notificationModal").modal("show");
      this.confirmModalTitle = this.$t('socialNetwork.notiAddSocialAccountLink',
        { '0': this.socialNetworkTypeSelect === SocialNetworkType.GOOGLE ? 'google' : 'facebook' })
    },
    onClickCloseModal: function () {
      $("#notificationModal").modal("hide");
    },
    getFullAddress: function () {
      this.fullAddress = this.address.street
      let addressFilter = {
        params: {
          countryCode: 84,
          cityCode: this.address.province,
          districtCode: this.address.district,
          wardCode: this.address.ward
        }
      }
      this.GET_ADDRESS_DETAIL(addressFilter).then(
        function (res) {
          this.fullAddress = functionUtils.concatFullAddress(res.data, this.address.street)
        }.bind(this)
      )
    },
    onEditAddress: function () {
      this.$refs.editAddressModal.onShowModal(this.address, false)
    },
    onUpdateAddress: function (address) {
      this.address.province = address.province
      this.address.district = address.district
      this.address.ward = address.ward
      this.address.longitude = address.longitude
      this.address.latitude = address.latitude
      this.address.street = address.street
      this.getFullAddress()
    },
    ...mapActions([
      'SET_USER_DATA',
      'UPDATE_CURRENT_USER',
      'LOGOUT',
      'SOCIAL_NETWORK_LOGIN',
      'GET_SOCIAL_NETWORK',
      'GET_ADDRESS_DETAIL'
    ]),
  },
};
</script>

<style lang="scss" scoped>
  @import "@/styles/color.scss";
  .header-page {
    width: 100%;
    height: 15vh;
    background-color: $second;
  }
  .profile-page {
    width: 50.5vw;
    font-family: Roboto;
    color: $primary;
    font-size: 15px;
    margin-top: 40px;
    margin: 0 auto;
    transform:translate(0px, -5vh);

    ::-webkit-input-placeholder { /* Edge */
      font-size: 14px;
      color: $primary;
    }

    :-ms-input-placeholder { /* Internet Explorer */
      font-size: 14px;
      color: $primary;
    }

    ::placeholder {
      font-size: 14px;
      color: $primary;
    }

    input, select, textarea{
      color: $primary;

    }

    form {
      background-color: #F7FAFC;
      box-shadow: 0 2px 17px 0 rgba(0, 0, 0, 0.1);
      padding: 16px 38px 45px 38px;
      border-radius: 10px;
      padding: 0px 25px 40px 25px;

      .title-form {
        font-size: 18px;
        font-weight: 600;
        padding: 21px 0px 40px 0px;
        text-align: center;
        position: relative;
      }
      .btn-close-form {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-80%);
        background: none;
        border: none;
        font-size: 24px;
        font-weight: bold;
        line-height: 1;
        color: #666;
        cursor: pointer;
        padding: 5px;
      }
      .btn-close-form:hover {
        color: #ff0000;
      }

      .form-group {
        padding: 0 15px;

        input {
          height: 30px;
          border: none;
          color: $primary !important;
          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);

          &:focus {
            border: 1px solid $primary;
          }
        }

        .input-date-of-birth {
          :deep(.mx-datepicker) {
            width: 100%;
            input {
              height: 30px;
              border: none;
              color: $primary !important;
              box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);

              &:focus {
                border: 1px solid $primary;
              }
            }
          }
        }

        .selectbox-gender {
          height: 30px;
          border: none;
          color: $primary !important;
          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);

          &:focus {
            border: 1px solid $primary;
          }
        }
      }

      .button-save {
        border: 1px solid $primary;
        color: $primary;

        &:hover {
          background-color: $primary;
          color: #fff
        }

        &:active {
          background-color: #b05c42;
        }

        &:focus {
          box-shadow: none;
        }
      }
    }
  }
  @media only screen and (max-width: 1200px) {
    .profile-page {
      width: 70vw;
    }
  }

  @media only screen and (max-width: 769px) {
    .profile-page {
      width: 90vw;
    }
  }
</style>
